import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';

const Header = () => {
  const [show,setShow] = useState(false)
  return (
    <>
      <div className='MainHeader'>
        <div className='HeaderLogo'>
            <Link to="/"><h3>Developer Shaon</h3></Link>
        </div>
        <div className='HeaderLinks'>
            <ul>
                <Link to="/"><li>Home</li></Link>
                <Link to="/about"><li>About</li></Link>
                <Link to="/service"><li>Service</li></Link>
                <Link to="/portfolio"><li>Portfolio</li></Link>
                <Link to="/team"><li>Team</li></Link>
                <Link to="/contact"><li>Contact</li></Link>
            </ul>
            <Outlet />
        </div>

        <div className='mobileMenu'>
        <i className="fa fa-th-large" onClick={()=>setShow(!show)}></i>
        </div>
      </div>

      <div className='mobileMenus'>
            {
              show ? <ul>
              <Link to="/"><li>Home</li></Link>
              <Link to="/about"><li>About</li></Link>
              <Link to="/service"><li>Service</li></Link>
              <Link to="/portfolio"><li>Portfolio</li></Link>
              <Link to="/team"><li>Team</li></Link>
              <Link to="/contact"><li>Contact</li></Link>
          </ul> : <p></p>
            }
      </div>
      
    </>
  )
}

export default Header
